import _ from 'underscore';
import Backbone from 'backbone';

import i18n from '../../utils/i18n';

export default Backbone.Model.extend({
	idAttribute: 'Id',
	updateTimeout: null,
	timeoutInterval: 60 * 1000, // 1 minute in MS

	defaults: function() {
		return {
			Buy: false,
			ConfirmButton: '',
			ConfirmLink: '',
			Currency: 'CHF',			// defaults to CHF
			DenyButton: '',
			DenyLink: '',
			ExpireDateTimestamp: 0,
			InstrumentName: '',
			Isin: '',
			IsSelected: false,
			NotificationSent: 0,		// minutes in the past
			NotificationSentString: 0,		// minutes in the past
			MinutesLeft: 0,				// minutes
			Price: 0,
			PriceFormatted: '',
			Quantity: 0,
			QuantityFormatted: '',
			Text: '',
			TradeDateTimestamp: 0,
			TradeReportId: null,
			TradeType: '',
			TransactionType: ''
		};
	},

	initialize: function() {
		this.setUpdateTimeout();
	},

	// parse and set formatted attributes
	parse: function(attributes) {
		var transactionType = (attributes.Buy === true) ? 'BUY' : 'SELL',
			notificationSentString = this.getNotificationSentTime(attributes.NotificationSent);

		return _.extend({}, attributes, {
			NotificationSentString: notificationSentString,
			TransactionType: transactionType
		});
	},

	// set a timeout to update the times (minutes left, notification sent)
	setUpdateTimeout: function() {
		this.updateTimeout = setTimeout(this.updateNotificationTimes.bind(this), this.timeoutInterval);
	},

	// clear timeout
	clearUpdateTimeout: function() {
		this.clearTimeout(this.updateTimeout);
	},

	// updates minutes left and notification sent time
	updateNotificationTimes: function() {
		var minutesLeft = this.get('MinutesLeft'),
			notificationSent = this.get('NotificationSent');

		// update time remaining
		if (minutesLeft > 0) {
			this.set('MinutesLeft', Math.max(parseInt(minutesLeft - 1), 0));
		}

		// update notification time
		this.set('NotificationSent', parseInt(notificationSent) + 1);
		this.set('NotificationSentString', this.getNotificationSentTime(this.get('NotificationSent')));

		this.setUpdateTimeout();
	},

	// convert minutes to a string in x hours, xx minutes
	getNotificationSentTime: function(totalMinutes) {
		var minutes = totalMinutes,
			hours = Math.floor(totalMinutes / 60),
			timeString = '';

		if (hours > 0) {
			hours += (hours > 1) ? ' hours' : ' hour';
			minutes = totalMinutes % 60;

			timeString = hours + ', ';
		}

		minutes += ' min.';

		timeString += minutes;

		return timeString;
	},

	toJSON: function() {
		var data = _.clone(this.attributes);

		return _.extend(data, {
			PriceFormatted: i18n.formatNumber(parseFloat(data.Price)),
			QuantityFormatted: i18n.formatNumber(parseFloat(data.Quantity))
		});
	}

});

